"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformCurrencyToCurrencyName = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const transformCurrencyToCurrencyName = (currency) => {
    switch (currency) {
        case legacy_enums_1.Currency.Euro:
            return "Euro";
        case legacy_enums_1.Currency.Dollar:
            return "U. S. Dollar";
        case legacy_enums_1.Currency.CanadianDollar:
            return "Canadian Dollar";
        case legacy_enums_1.Currency.AustralianDollar:
            return "Australian Dollar";
        case legacy_enums_1.Currency.BritishPound:
            return "Pound Sterling";
        case legacy_enums_1.Currency.NewZealandDollar:
            return "New Zealand Dollar";
        case legacy_enums_1.Currency.CzechKoruna:
            return "Czech Koruna";
        default:
            return "";
    }
};
exports.transformCurrencyToCurrencyName = transformCurrencyToCurrencyName;
//# sourceMappingURL=transformCurrencyToCurrencyName.js.map